export default __webpack_public_path__ + "static/media/up.0993dda9.svg";